import { useEffect as s } from "react";
import { enUS as i } from "../../../node_modules/date-fns/locale/en-US.mjs";
import { LanguageCodeEnum as e } from "../../../libs/types/dist/index12.mjs";
const k = (t, r) => {
  s(() => {
    (async () => {
      try {
        if (t) {
          let a;
          switch (t) {
            case e.ENGLISH:
            case "en":
              a = (await import("../../../node_modules/date-fns/locale/en-US.mjs")).enUS;
              break;
            case e.FRENCH:
            case "fr":
              a = (await import("../../../node_modules/date-fns/locale/fr.mjs")).fr;
              break;
            case e.SPANISH:
            case "es":
              a = (await import("../../../node_modules/date-fns/locale/es.mjs")).es;
              break;
            case e.ITALIAN:
            case "it":
              a = (await import("../../../node_modules/date-fns/locale/it.mjs")).it;
              break;
            case e.PORTUGUESE:
            case "pt":
              a = (await import("../../../node_modules/date-fns/locale/pt.mjs")).pt;
              break;
            case e.DEUTSCH:
            case "de":
              a = (await import("../../../node_modules/date-fns/locale/de.mjs")).de;
              break;
            case e.DUTCH:
            case "nl":
              a = (await import("../../../node_modules/date-fns/locale/nl.mjs")).nl;
              break;
            case e.RUSSIAN:
            case "ru":
              a = (await import("../../../node_modules/date-fns/locale/ru.mjs")).ru;
              break;
            case e.JAPANESE:
            case "ja":
              a = (await import("../../../node_modules/date-fns/locale/ja.mjs")).ja;
              break;
            case e.ARABIC:
            case "ar":
              a = (await import("../../../node_modules/date-fns/locale/ar.mjs")).ar;
              break;
            case e.TURKISH:
            case "tr":
              a = (await import("../../../node_modules/date-fns/locale/tr.mjs")).tr;
              break;
            case e.CHINESE:
            case "zh":
              a = (await import("../../../node_modules/date-fns/locale/zh-CN.mjs")).zhCN;
              break;
            case e.SWEDISH:
            case "sv":
              a = (await import("../../../node_modules/date-fns/locale/sv.mjs")).sv;
              break;
            case e.ROMANIAN:
            case "ro":
              a = (await import("../../../node_modules/date-fns/locale/ro.mjs")).ro;
              break;
            case e.CZECH:
            case "cs":
              a = (await import("../../../node_modules/date-fns/locale/cs.mjs")).cs;
              break;
            case e.HUNGARIAN:
            case "hu":
              a = (await import("../../../node_modules/date-fns/locale/hu.mjs")).hu;
              break;
            case e.SLOVAK:
            case "sk":
              a = (await import("../../../node_modules/date-fns/locale/sk.mjs")).sk;
              break;
            case e.DANISH:
            case "da":
              a = (await import("../../../node_modules/date-fns/locale/da.mjs")).da;
              break;
            case e.INDONESIAN:
            case "id":
              a = (await import("../../../node_modules/date-fns/locale/id.mjs")).id;
              break;
            case e.POLISH:
            case "pl":
              a = (await import("../../../node_modules/date-fns/locale/pl.mjs")).pl;
              break;
            case e.GREEK:
            case "el":
              a = (await import("../../../node_modules/date-fns/locale/el.mjs")).el;
              break;
            case e.SERBIAN:
            case "sr":
              a = (await import("../../../node_modules/date-fns/locale/sr.mjs")).sr;
              break;
            case e.NORWEGIAN:
            case "no":
              a = (await import("../../../node_modules/date-fns/locale/nb.mjs")).nb;
              break;
            case e.THAI:
            case "th":
              a = (await import("../../../node_modules/date-fns/locale/th.mjs")).th;
              break;
            case e.SLOVENIAN:
            case "sl":
              a = (await import("../../../node_modules/date-fns/locale/sl.mjs")).sl;
              break;
            case e.UKRAINIAN:
            case "uk":
              a = (await import("../../../node_modules/date-fns/locale/uk.mjs")).uk;
              break;
            case e.ALBANIA:
            case "sq":
              a = (await import("../../../node_modules/date-fns/locale/sq.mjs")).sq;
              break;
            case e.HINDI:
            case "hi":
              a = (await import("../../../node_modules/date-fns/locale/hi.mjs")).hi;
              break;
            default:
              a = (await import("../../../node_modules/date-fns/locale/en-US.mjs")).enUS;
              break;
          }
          r(a);
        } else {
          const a = (await import("../../../node_modules/date-fns/locale/en-US.mjs")).enUS;
          r(a);
        }
      } catch (a) {
        console.error("Error loading locale:", a), r(i);
      }
    })();
  }, [t, r]);
};
export {
  k as useDateFnsLocale
};
